import script from "./JobTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./JobTasks.vue?vue&type=script&setup=true&lang=js"

import "./JobTasks.vue?vue&type=style&index=0&id=a3177fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3177fc8"]])

export default __exports__